var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTaskInspectionFireTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M22.001 9h-1V7c0-1.1-.9-2-2-2V4h-2v1h-1V.002h-1v1H9v-1H8v5H7V4H5v1c-1.1 0-2 .9-2 2V9H2c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1h1v5H2c-.6 0-1 .4-1 1s.4 1.001 1 1.001h1v1.997a1 1 0 0 0 1 1h2a1 1 0 0 0 1.001-1v-1.997h10v1.998a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.998H22c.6 0 1-.4 1-1s-.4-1-1-1h-1v-5h1c.6 0 1-.4 1-1v-3C23 9.4 22.601 9 22.001 9m-13-7h6v1H9zm0 2h6v1H9zM5 7h6v5H5zm11 12h-8v-5h8zm-3-7V7h6v5zm-6.52 5.88a1.08 1.08 0 1 1-2.16 0 1.08 1.08 0 0 1 2.16 0m12.12 1.08a1.08 1.08 0 1 0 0-2.16 1.08 1.08 0 0 0 0 2.16",
  clipRule: "evenodd"
})));
export default SvgTaskInspectionFireTruck;